module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_5_1.1541fa71.png";